module.exports = __webpack_public_path__ + "static/media/badge-apple-app-store.2a5dde17.png";